module.exports = __webpack_public_path__ + "img/icon_goods.3202a6d8.png";